{
  "it": {
    "published": {
      "labels": {
        "publishedCustomerPartners": "Pubblicato per clienti e partner",
        "publishedCustomer": "Pubblicato per i clienti",
        "publishedPartners": "Pubblicato per i partner",
        "notPublished": "Non pubblicato"
      },
      "publish_mode": {
        "inherit": "Segui il modello",
        "inherit_info": "Mantiene lo stato pubblicato o non pubblicato di ogni elemento del modello",
        "publish": "Pubblica per i clienti",
        "publish_info": "I clienti possono vederli subito",
        "title": "Pubblicazione",
        "unpublished": "Crea senza pubblicare",
        "unpublished_info": "Nascosto ai clienti finché non vengono pubblicati"
      }
    }
  }
}
